import React from 'react'
import { Link } from 'react-router-dom'

/** Video file: `public/assets/images/banner/bannervideoo.mp4` (no HTML overlays — text is baked into the video). */
const VIDEO_SRC = `${process.env.PUBLIC_URL || ''}/assets/images/banner/bannervideoo.mp4`

function BannerVideo() {
    return (
        <section
            id="banner"
            className="rts-banner-area td-banner-video"
            aria-label="Hero"
        >
            <Link
                to="/contactus"
                className="td-banner-video__link"
                aria-label="Contact us"
            >
                <div className="td-banner-video__media">
                    <video
                        className="td-banner-video__el"
                        autoPlay
                        muted
                        loop
                        playsInline
                        preload="metadata"
                    >
                        <source src={VIDEO_SRC} type="video/mp4" />
                    </video>
                </div>
            </Link>
        </section>
    )
}

export default BannerVideo
